module.exports = __webpack_public_path__ + "static/media/TOMO.01dbef0a.svg";